import { gql } from "@apollo/client";
import {MEDIA_FIELDS} from "./common"

export const FONT_FIELDS = gql`
${MEDIA_FIELDS}
fragment FontFields on Font {
    id
    name
    media {...MediaFields}
  
    isPublishable
    hasMediaValid
}`

export const FONT_ASSET_FIELDS = gql`
${FONT_FIELDS}
fragment FontAssetFields on FontAsset {
    id
    ownerPartyId
    public
    font {...FontFields}
    createdAt
    updatedAt
  
    isPublishable
    hasMediaValid
}`